import { Component, computed, inject, input } from '@angular/core'

import { Meeting } from '../../shared/data-models/meeting'
import { MeetingPage } from '../../shared/data-models/meeting-page'
import { MeetingPageType } from '../../shared/enums/meeting-page-type'
import { MeetingTimerService } from '../../shared/services/meeting-timer.service'
import { ToDosComponent } from '../to-dos/to-dos.component'

@Component({
    selector: 'app-wrap-up',
    templateUrl: './wrap-up.component.html',
    styleUrls: ['./wrap-up.component.css'],
    standalone: true,
    imports: [ToDosComponent],
})
export class WrapUpComponent {
    timerService = inject(MeetingTimerService)

    meetingId = input.required<string>()
    meetings = input.required<Meeting[]>()
    meeting = input.required<Meeting>()
    pages = input.required<MeetingPage[]>()

    selectedRating = 0
    hoverRating = 0

    // Computed property to get page times with formatting, excluding Wrap-up pages
    pageTimes = computed(() => {
        return this.pages()
            .filter(page => page.pageType !== MeetingPageType.Wrapup)
            .map((page, index) => ({
                page,
                timeSpent: this.timerService.getPageTime(index)?.() || 0,
                timeFormatted: this.formatTime(this.timerService.getPageTime(index)?.() || 0),
            }))
    })

    // Computed property to calculate total meeting time
    totalMeetingTime = computed(() => {
        const totalSeconds = this.pageTimes().reduce((sum, pageTime) => sum + pageTime.timeSpent, 0)
        return {
            timeSpent: totalSeconds,
            timeFormatted: this.formatTime(totalSeconds),
        }
    })

    setRating(rating: number): void {
        this.selectedRating = rating
        // TODO: Save rating to backend when implemented
        console.log(`Meeting rated: ${rating} stars`)
    }

    onStarHover(rating: number): void {
        this.hoverRating = rating
    }

    onStarLeave(): void {
        this.hoverRating = 0
    }

    isStarActive(starNumber: number): boolean {
        return starNumber <= (this.hoverRating || this.selectedRating)
    }

    private formatTime(totalSeconds: number): string {
        const minutes = Math.floor(totalSeconds / 60)
        const seconds = totalSeconds % 60
        return `${minutes}:${seconds.toString().padStart(2, '0')}`
    }
}
